/* eslint-disable no-use-before-define */
import React from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from '@mui/material/Autocomplete';
import "../styles/components/DropDownWithLabel.scss";
import makeStyles from '@mui/styles/makeStyles';

const DropDownWithSearch = (props) => {
  setTimeout(async () => {
    const close = await document.getElementsByClassName(
      "MuiAutocomplete-clearIndicator"
    )[0];
    if (close) {
      close.addEventListener("click", () => {
        const handleChnage = props?.options?.handleChange;
        if (handleChnage) {
          handleChnage(undefined);
        }
      });
    }
  }, 0);

  const getValue = () => {
    const options = props.options;
    if (options && options.items && options.items.length > 0 && options.value) {
      return options.value;
    }
    return "";
  };

  const useStyles = makeStyles((theme) => ({
    popupIndicator: {
      "& span": {
        "& svg": {
          "& path": {
            d: "path('M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z')",
          },
        },
      },
    },
  }));
  const classes = useStyles();

  return (
    <Autocomplete
      disabled={props.promomatsDisabled}
      id="search-and-select"
      style={{ width: "100%" }}
      options={props.options.items}
      value={getValue()}
      onChange={(event, value) => {
        props.options.handleChange(value);
      }}
      isOptionEqualToValue={(option) => {
        return option.displayName === props.options.value?.displayName;
      }}
      clearIcon={""}
      closeText=""
      openText=""
      className="drop-down-with-search hideArrow custonScrollBar myAutocomplete"
      autoHighlight
      getOptionLabel={(option) => option.displayName || ""}
      classes={{
        clearIndicatorDirty: classes.clearIndicator,
        popupIndicator: classes.popupIndicator,
        paper: classes.menuItemBox,
      }}
      renderOption={(option) => (
        <React.Fragment>
          <span className="display-name">{option.displayName}</span>
        </React.Fragment>
      )}
      renderInput={(params, option) => (
        <TextField
          {...params}
          label={props.options.label}
          variant="standard"
          inputProps={{
            ...params.inputProps,
            title: "",
          }}
          className="templateNameTextfield marketFieldTemp"
        />
      )}
    />
  );
};

export default DropDownWithSearch;
